import axios from 'axios';

const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_PLACES_API_TOKEN;
const GOOGLE_PLACES_BASE_URL = "https://places.googleapis.com/v1/";

const googleMapsApi = axios.create({
  baseURL: GOOGLE_PLACES_BASE_URL,
});

export async function googleMapsRequest(endpoint, requestBody, headers) {
  try {
    const response = await googleMapsApi.post(`${endpoint}?key=${GOOGLE_MAPS_API_KEY}`, requestBody, { headers });
    return response.data;
  } catch (error) {
    console.error("Google Maps API Error:", error);
    throw error;
  }
}

export function getGoogleMapLocationLink({longitude, latitude}) {
  return`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
}